/* eslint-disable */
import React, { Dispatch, useEffect } from 'react';
import XLSX from 'xlsx';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Dialog from '@material-ui/core/Dialog';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import { get } from "lodash";
import GetAppIcon from '@material-ui/icons/GetApp';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import AddIcon from '@material-ui/icons/Add';
import FullscreenLoader from './../../common/components/FullscreenLoader';
import moment from "moment-timezone";
import NotificationIcon from '../../common/components/NotificationIcon';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import AddNewAnnexurePart from './AddNewAnnexurePart';
import { getAnnexureList, updateAnnexurePart, deleteAnnexurePart, editAnnexurePart, getAllAnnexureList } from '../../store/actions/annexureParts.actions';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { getNewBrand } from '../../common/components/util';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from '@material-ui/icons/Search';
import { getMaterialGroups } from '../../store/actions/materialGroups.actions';
import Tooltip from '@material-ui/core/Tooltip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WarningIcon from "@material-ui/icons/Warning";
import DialogContentText from '@material-ui/core/DialogContentText';
import ImportDialog from './ImportExcelDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  actionButton: {
    color: '#1A9FE0',
  },
  tableCell: {
    backgroundColor: 'transparent',
  },
  actionButtonTable: {
    padding: 4,       // or even 0 if needed
    marginRight: 8,
    color: '#00AEEF', // match your icon color
  },
  yes: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#1A9FE0',
    textTransform: 'capitalize'
  },
  addUpdateDailogTitle: {
    position: "absolute",
    top: 10,
    left: 10
  },
  icon: {
    float: "left",
    margin: "0 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  cancel: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#919191',
    textTransform: 'capitalize'
  },
  menuItem: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 12,
    minHeight: '32px',
  },
  logoutText: {
    color: '#616161',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'inherit',
    textAlign: 'left',        // <-- key change
    lineHeight: '1.6',
    paddingLeft: '8px'        // <-- ensures alignment under the icon
  },
  iconButton: {
    padding: 10,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,

  },
  title: {
    flex: '1 1 100%',
    fontSize: 30,
  },
  button: {
    borderRadius: "1.25rem",
    minWidth: 170,
    margin: "0 0 0 .5%",
    backgroundColor: "#1A9FE0",
    color: "white",
    height: "2.25rem",
    fontSize: "0.7rem",

  },
  inCellButton: {
    color: '#1A9FE0',
    textTransform: 'none',
    fontSize: 12,
    padding: "0 0.9rem",
  },
  header: {
    color: "#133F8A",
    fontWeight: 900,
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    textAlign: 'left',
    minWidth: 90,
    maxWidth: 120
  },
  subHeader: {
    backgroundColor: '#fafafa',
    fontWeight: 500,
    fontSize: '13px',
    color: '#666',
    textAlign: 'center',
    borderBottom: '1px solid #e0e0e0',
  },
  bodyContent: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
  },
  closeButton: {
    backgroundColor: '#EAEAEA',
    width: 140,
    fontWeight: 800,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#666666',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 24
  },
  bodyContentActionHeader: {
    color: "#133F8A",
    fontWeight: 900,
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    textAlign: 'left',
    maxWidth: 60
  },
  bodyContentAction: {
    maxWidth: 60
  },
}));
const theme = createTheme({
  palette: {
    secondary: {
      main: '#1A9FE0'
    },
  }
});

export default function AnnexurePartList() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;
  const dispatch: Dispatch<any> = useDispatch();
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [searchText, setSearchText] = React.useState<any>('');
  const { getAnnexureListData, importAnnexurePart }: any = useSelector((state: any) => state.annexure)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isEdit, setIsEdit] = React.useState(false);
  const [selectedPartNumber, setSelectedPartNumber] = React.useState<any>('');
  const [openDialog, setOpenDialog] = React.useState<any>(false);
  const [loading, setLoading] = React.useState<any>(false);
  const [openUploadImportExcel, setOpenUploadImportExcel] = React.useState(false);
  let userTypeByProfileAPI = sessionStorage.getItem('userType-Profile-API');
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, partNumber: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedPartNumber(partNumber);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  useEffect(() => {
    dispatch(getMaterialGroups());
  }, []);

  useEffect(() => {
    if (importAnnexurePart && importAnnexurePart.data && importAnnexurePart.data.data) {
      setSuccessMessage(importAnnexurePart.data?.message?.message);
      handleopenCloseSnackbar(true);
      setLoading(false);
      dispatch(getAnnexureList(0, rowsPerPage, ""));
    }
  }, [importAnnexurePart]);


  useEffect(() => {
    if (searchText === "") {
      dispatch(getAnnexureList(0, rowsPerPage, ""));
    }
  }, [searchText, dispatch]);

  const handleSearch = async (pageNumber: number) => {
    setPage(pageNumber);
    const filter = searchText.length >= 5 ? searchText : "";
    const data: any = await dispatch(getAnnexureList(pageNumber * 10, rowsPerPage, filter));
    if (data?.error) {
      setSuccessMessage(typeof data?.error === 'string' ? data?.error : data?.error?.error ? data?.error?.error : 'Error Occured');
      handleopenCloseErrorSnackbar(true);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    handleSearch(newPage);
  };


  // const handleCloseAnchor = () => {
  //     setAnchorEl(null);
  // };

  // const handleClick = (event: any) => {
  //     setAnchorEl(event.currentTarget);
  // };

  const exportData = async () => {
    let annexureData: any = await dispatch(getAllAnnexureList());
    if (annexureData && annexureData.data) {
      let filename = 'AnnexurePartsList.xlsx';

      const productData = annexureData?.data?.productData;
      // Define header rows
      const headerRow1 = [
        'Part Number', 'Brand Name', 'Description',
        'Quantity Tier Range', '', '', '', '', '',
        'Price Tier Range', '', '', '', '', '', '', '', ''
      ];

      const headerRow2 = [
        '', '', '',
        'Tier 1', '', 'Tier 2', '', 'Tier 3', '',
        'Tier 1', '', '', 'Tier 2', '', '', 'Tier 3', '', ''
      ];

      const headerRow3 = [
        '', '', '',
        'Min qty', 'Max qty', 'Min qty', 'Max qty', 'Min qty', 'Max qty',
        'Gold', 'Platinum', 'Elite', 'Gold', 'Platinum', 'Elite', 'Gold', 'Platinum', 'Elite'
      ];

      const rows = productData?.map((item: any) => [
        item.partNumber,
        item.brand,
        item.description,
        Number(item.quantityTierRange.tier_1.minQty),
        Number(item.quantityTierRange.tier_1.maxQty),
        Number(item.quantityTierRange.tier_2.minQty),
        Number(item.quantityTierRange.tier_2.maxQty),
        Number(item.quantityTierRange.tier_3.minQty),
        Number(item.quantityTierRange.tier_3.maxQty),
        Number(item.priceTierRange.tier_1.gold),
        Number(item.priceTierRange.tier_1.platinum),
        Number(item.priceTierRange.tier_1.elite),
        Number(item.priceTierRange.tier_2.gold),
        Number(item.priceTierRange.tier_2.platinum),
        Number(item.priceTierRange.tier_2.elite),
        Number(item.priceTierRange.tier_3.gold),
        Number(item.priceTierRange.tier_3.platinum),
        Number(item.priceTierRange.tier_3.elite)
      ]);

      const sheetData = [headerRow1, headerRow2, headerRow3, ...rows];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

      // Define merged cells as per your requirement
      worksheet['!merges'] = [
        // PartNumber header
        { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // A1:A3

        // Make
        { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } }, // B1:B3

        // Description
        { s: { r: 0, c: 2 }, e: { r: 2, c: 2 } }, // C1:C3

        // QuantityTierRange
        { s: { r: 0, c: 3 }, e: { r: 0, c: 8 } }, // D1:I1
        { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, // D2:E2 (Tier 1)
        { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } }, // F2:G2 (Tier 2)
        { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // H2:I2 (Tier 3)

        // PriceTierRange
        { s: { r: 0, c: 9 }, e: { r: 0, c: 17 } }, // J1:R1
        { s: { r: 1, c: 9 }, e: { r: 1, c: 11 } }, // J2:L2 (Tier 1)
        { s: { r: 1, c: 12 }, e: { r: 1, c: 14 } }, // M2:O2 (Tier 2)
        { s: { r: 1, c: 15 }, e: { r: 1, c: 17 } }, // P2:R2 (Tier 3)
      ];


      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ProductData');
      XLSX.writeFile(workbook, filename);
    }
  }

  const handleUploadImportExcel = async () => {
    setOpenUploadImportExcel(false);
  }

  return (
    <div className={classes.root}>
      {loading && <FullscreenLoader />}
      <Snackbar
        open={openSnackbar}
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} />
      {getAnnexureListData && getAnnexureListData.loading && <FullscreenLoader />}
      <div className="d-flex align-items-center">
        <h2 className="page-title">
          Annexure/Core Products List</h2>
        <div className="ml-auto">
          {/* <AnnouncementIcon /> */}
          <NotificationIcon />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center mb-2">
            <p className="dealer-table-title-parts-list">List of Annexure/Core Products</p>
            <div className="row-space-start ml-auto pr-2">
              <Tooltip title="Enter at least 5 characters to search." placement="top">
                <TextField
                  placeholder="Search by Part No."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && searchText.length >= 5) {
                      handleSearch(0);
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            if (searchText.length >= 5) {
                              handleSearch(0);
                            }
                          }}
                          disabled={searchText.length < 5}
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  className="pill-search-input"
                />
              </Tooltip>
              <div className='px-2'></div>
              {userTypeByProfileAPI === "FSE" || userTypeByProfileAPI === "KAM" ? '' : (
                <Button
                  variant="contained"
                  color="secondary"
                  className="createFavourite ml-2"
                  startIcon={<AddIcon />}
                  // disabled
                  size="large"
                  onClick={() => {
                    setIsEdit(false);
                    handleClickOpen();
                  }}
                >
                  Add New
                </Button>
              )}
            </div>
            {userTypeByProfileAPI === "FSE" || userTypeByProfileAPI === "KAM" ? '' : (
              <div className='pr-2'>
                <ImportDialog />
              </div>
            )}
            <div className='pr-2'>
              <IconButton
                className="ml-2 file-close-color" size="small"
                onClick={() => exportData()}
              >
                <GetAppIcon fontSize="inherit" />
                <span className="font-size-14 file-close-color ml-1">
                  Export To Excel
                </span>
              </IconButton>
            </div>
          </div>
          <div className="cardCommon mh-300p">
            <Grid item xs={12} className="mt-2 cardCommon">
              <TableContainer component={Paper} className="height-500">
                {<Table aria-label="dealer table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <div className="dealer-table-title">Part No.</div>
                        <div className="dealer-table-title-desc pt-1 pb-1">Brand</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title pb-1">Description</div>
                        <div className="dealer-table-title-desc pt-3 pb-1"></div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title">Min</div>
                        <div className="dealer-table-title-desc pt-1 pb-1">Tier:1</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:2</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:3</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title">Gold</div>
                        <div className="dealer-table-title-desc pt-1 pb-1">Tier:1</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:2</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:3</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title">Platinum</div>
                        <div className="dealer-table-title-desc pt-1 pb-1">Tier:1</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:2</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:3</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title">Elite</div>
                        <div className="dealer-table-title-desc pt-1 pb-1">Tier:1</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:2</div>
                      </TableCell>
                      <TableCell>
                        <div className="dealer-table-title"></div>
                        <div className="dealer-table-title-desc pt-3 pb-0">Tier:3</div>
                      </TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          <div
                            className='mb-2'
                            style={{
                              color: '#133F8A',
                              opacity: 1,
                              fontSize: '0.80rem',
                              fontWeight: 700,
                              fontFamily: 'Nunito',
                            }}
                          >
                            Updated By
                          </div>
                          <div style={{ paddingTop: '6px', paddingBottom: '4px' }}></div>
                        </div>
                      </TableCell>

                      <TableCell>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          <div
                            className='mb-2'
                            style={{
                              color: '#133F8A',
                              opacity: 1,
                              fontSize: '0.80rem',
                              fontWeight: 700,
                              fontFamily: 'Nunito',
                            }}
                          >
                            Updated On
                          </div>
                          <div style={{ paddingTop: '6px', paddingBottom: '4px' }}></div>
                        </div>
                      </TableCell>
                      {userTypeByProfileAPI === "FSE" || userTypeByProfileAPI === "KAM" ? '' : (
                        <TableCell>
                          <div className="dealer-table-title mb-2">Action</div>
                          <div className="dealer-table-title-desc pt-2 pb-1"></div>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getAnnexureListData?.data?.data?.productData?.map((item: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell>
                          <div className="dealer-table-content">{item.partNumber}</div>
                          <div className="dealer-table-subcontent pt-1">{item.brand ? getNewBrand(item.brand) : "-"}</div>
                        </TableCell>
                        <TableCell>
                          <div className="dealer-table-content pb-3 mt-2">{item.description || "TEST"}</div>
                        </TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.quantityTierRange?.tier_1?.minQty || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.quantityTierRange?.tier_2?.minQty || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.quantityTierRange?.tier_3?.minQty || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_1?.gold || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_2?.gold || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_3?.gold || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_1?.platinum || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_2?.platinum || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_3?.platinum || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_1?.elite || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_2?.elite || "-"}</div></TableCell>
                        <TableCell><div className="dealer-table-content pb-3">{item.priceTierRange?.tier_3?.elite || "-"}</div></TableCell>
                        <TableCell>
                          <div className="dealer-table-content">{item.updatedBy}</div>
                          <div className="dealer-table-subcontent pt-1">Emp ID: {item.empId}</div>
                        </TableCell>
                        <TableCell>
                          <div className="dealer-table-content">
                            {item.updatedOn ? moment(item.updatedOn, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY") : "-"}
                          </div>
                          <div className="dealer-table-subcontent pt-1">
                            {item.updatedOn ? moment(item.updatedOn, "DD-MM-YYYY hh:mm A").format("hh:mm A") : "-"}
                          </div>
                        </TableCell>
                        {userTypeByProfileAPI === "FSE" || userTypeByProfileAPI === "KAM" ? '' : (
                          <TableCell>
                            <div style={{ background: "white" }}>
                              <IconButton
                                onClick={(event: any) => handleClick(event, item.partNumber)}
                                className={classes.actionButton}
                                size="small"
                              >
                                <div className="px-2 pt-1 pb-1 boxshadow-icon">
                                  <MoreVertIcon fontSize="inherit" className={classes.actionButton} />
                                </div>
                              </IconButton>
                            </div>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                  {userTypeByProfileAPI === "FSE" || userTypeByProfileAPI === "KAM" ? '' : (
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleCloseAnchor}
                      keepMounted
                      anchorReference="anchorEl"
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                      className="mt-5 px-2"
                    >
                      <MenuItem className='px-3'>
                        <Button
                          className="text-info px-2"
                          startIcon={<EditOutlinedIcon />}
                          onClick={async () => {
                            setIsEdit(true);
                            handleClickOpen();
                            const data: any = await dispatch(editAnnexurePart(selectedPartNumber));
                            if (data?.error) {
                              setSuccessMessage(typeof data?.error === 'string' ? data?.error : data?.error?.error ? data?.error?.error : 'Error Occured');
                              handleopenCloseErrorSnackbar(true);
                            }
                            handleCloseAnchor();
                          }}
                        >
                          <div className="font-dropdown">Edit</div>
                        </Button>
                      </MenuItem>

                      <MenuItem>
                        <Button
                          className="text-info px-2"
                          startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                          onClick={async () => {
                            setOpenDialog(true);
                          }}
                        >
                          <div className="font-dropdown">Delete</div>
                        </Button>
                      </MenuItem>
                    </Menu>

                  )}
                </Table>}
                {getAnnexureListData?.data?.data?.productData?.length == 0 && (
                  <div className="my-5 mx-auto text-center">
                    No data found.
                  </div>
                )}
                {<div className="col-12 d-flex justify-content-end">
                  <TablePagination
                    rowsPerPageOptions={[rowsPerPage]}
                    component="div"
                    count={
                      getAnnexureListData?.data?.data?.count ?? 0
                    }
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                  />
                </div>}
              </TableContainer>
            </Grid>
          </div>
        </div>
      </div>
      <React.Fragment>
        <Dialog
          disableBackdropClick={true}
          open={openDialog}
          fullWidth={true}
          maxWidth={'sm'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className='mt-2'>
            <div className={`mt-2 ${classes.icon}`}>
              <WarningIcon className="delete-warning" fontSize="small" />
            </div>
            <div>
              <DialogContentText id="alert-dialog-description">
                <div className="shift-to-party-page-title">
                  Confirm Delete
                </div>
                <div className={`mt-2 ${classes.logoutText}`}>
                  <p className="text-note-delete mt-2 px-5">
                    Are you sure you want to delete this part from the list ?
                  </p>
                </div>
              </DialogContentText>
            </div>
          </DialogContent>
          <DialogActions>
            <><Button
              variant="contained" className="border-left rounded-pill w-150p mt-2 mb-3"
              color="primary"
              onClick={async () => {
                setLoading(true);
                let payload = {
                  "partNumber": selectedPartNumber,
                  "deletedBy": userName,
                }
                const data: any = await dispatch(deleteAnnexurePart(payload));
                if (data?.error) {
                  setSuccessMessage(typeof data?.error === 'string' ? data?.error : data?.error?.error ? data?.error?.error : 'Error Occured');
                  handleopenCloseErrorSnackbar(true);
                  setLoading(false);
                } else {
                  handleCloseAnchor();
                  setOpenDialog(false);
                  setSuccessMessage("Part deleted successfully.");
                  handleopenCloseSnackbar(true);
                  setLoading(false);
                  setSearchText("");
                  setPage(0);
                  dispatch(getAnnexureList(0, rowsPerPage, ""));
                }
              }}>Confirm</Button>
              <Button
                variant="contained"
                className={`mt-2 mb-3 ${classes.closeButton}`}
                onClick={() => {
                  setOpenDialog(false);
                }}>Cancel</Button></>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        className="createFavoriteDialog"
        maxWidth="md"
      >
        <AddNewAnnexurePart setOpenDialog={handleClose} isEdit={isEdit} handleSearch={handleSearch} />
      </Dialog>
    </div>
  );
}